export const PastEvents = [
    {
        "date": "16/03/2024 - 17/03/2024",
        "name": "HACKHAZARDS '24",
        "image": "./img/events/NSCC_62_Poster.png"
    },
    {
        "date": "03/03/2024",
        "name": "Placement Session by Taruvar Mittal",
        "image": "./img/events/NSCC_61_Poster.jpg"
    },
    {
        "date": "27/01/2024",
        "name": "TechX 2.0 : DevOps",
        "image": "./img/events/techx2_8.png"
    },
    {
        "date": "26/01/2024",
        "name": "TechX 2.0 : Cyber Security",
        "image": "./img/events/techx2_7.png"
    },
    {
        "date": "25/01/2024",
        "name": "TechX 2.0 : Web Development",
        "image": "./img/events/techx2_6.png"
    },
    {
        "date": "24/01/2024",
        "name": "TechX 2.0 : AI & ML",
        "image": "./img/events/techx2_5.png"
    },
    {
        "date": "23/01/2024",
        "name": "TechX 2.0 : Blockchain",
        "image": "./img/events/techx2_4.png"
    },
    {
        "date": "22/01/2024",
        "name": "TechX 2.0 : App Development",
        "image": "./img/events/techx2_3.png"
    },
    {
        "date": "21/01/2024",
        "name": "TechX 2.0 : Open Source",
        "image": "./img/events/techx2_2.png"
    },
    {
        "date": "20/01/2024",
        "name": "TechX 2.0 : DSA & CP",
        "image": "./img/events/techx2_1.png"
    },
    {
        "date": "17/11/2023",
        "name": "Internal Meet",
        "image": "./img/events/NSCC_52_Poster.png"
    },
    {
        "date": "22/10/2023",
        "name": "API 101 using Postman",
        "image": "./img/events/NSCC_51_Poster.jpg"
    },
    {
        "date": "21/10/2023",
        "name": "Game of Codes 3.0",
        "image": "./img/events/NSCC_50_Poster.jpg"
    }
    ,
    {
        "date": "17/09/2023",
        "name": "SIH Guidance Session",
        "image": "./img/events/NSCC_48_Poster.jpg"
    },
    {
        "date": "11/08/2023",
        "name": "Webinar: MBA as a career choice",
        "image": "./img/events/NSCC_47_Poster.jpg"
    },
    {
        "date": "03/06/2023",
        "name": "Game of Codes 2.0",
        "image": "./img/events/NSCC_46_Poster.jpg"
    },
    {
        "date": "04/05/2023",
        "name": "Seminar by Miss Purva Aggarwal",
        "image": "./img/events/NSCC_45_Poster.jpg"
    },
    {
        "date": "01/05/2023 - 02/05/2023",
        "name": "Freshers' Placement Talk",
        "image": "./img/events/NSCC_43-44_Poster.jpg"
    },
    {
        "date": "29/04/2023",
        "name": "Introduction to Web Development",
        "image": "./img/events/NSCC_42_Poster.jpeg"
    },
    {
        "date": "25/04/2023",
        "name": "Webinar on Google Generation Scholarship",
        "image": "./img/events/NSCC_41_Poster.jpg"
    },
    {
        "date": "23/04/2023",
        "name": "TechX'23 - AR/VR/XR",
        "image": "./img/events/techx12.jpg"
    },
    {
        "date": "23/04/2023",
        "name": "TechX'23 - Mobile App Development",
        "image": "./img/events/techx11.jpg"
    },
    {
        "date": "22/04/2023",
        "name": "TechX'23 - UI/UX",
        "image": "./img/events/techx10.jpg"
    },
    {
        "date": "22/04/2023",
        "name": "TechX'23 - Web Development",
        "image": "./img/events/techx9.jpg"
    },
    {
        "date": "21/04/2023",
        "name": "TechX'23 - Open Source",
        "image": "./img/events/techx8.jpg"
    },
    {
        "date": "21/04/2023",
        "name": "TechX'23 - Cloud and DevOps",
        "image": "./img/events/techx7.jpg"
    },
    {
        "date": "14/04/2023",
        "name": "TechX'23 - DS",
        "image": "./img/events/techx6.jpg"
    },
    {
        "date": "16/04/2023",
        "name": "TechX'23 - AI and ML",
        "image": "./img/events/techx5.jpg"
    },
    {
        "date": "15/04/2023",
        "name": "TechX'23 - Blockchain and Web3.0",
        "image": "./img/events/techx4.jpg"
    },
    {
        "date": "15/04/2023",
        "name": "TechX'23 - Cyber Security",
        "image": "./img/events/techx3.jpg"
    },
    {
        "date": "14/04/2023",
        "name": "TechX'23 - CP",
        "image": "./img/events/techx2.jpg"
    },
    {
        "date": "14/04/2023",
        "name": "TechX'23 - DSA",
        "image": "./img/events/techx1.jpg"
    },
    {
        "date": "14/04/2023",
        "name": "TechXcelerate 2023",
        "image": "./img/events/NSCC_28-39_main-poster.jpg"
    },
    {
        "date": "04/04/2023",
        "name": "Interview Preparation Bootcamp",
        "image": "./img/events/NSCC_27_Poster.jpeg"
    },
    {
        "date": "22/03/2023",
        "name": "Coderush March Edition",
        "image": "./img/events/NSCC_26_Poster.jpg"
    },
    {
        "date": "28/01/2023",
        "name": "Coderush",
        "image": "./img/events/nsev25.jpg"
    },
    {
        "date": "11/01/2023",
        "name": "Podcast on Competitive Programming",
        "image": "./img/events/nsev24.png"
    },
    {
        "date": "07/01/2023",
        "name": "Web Dev Bootcamp",
        "image": "./img/events/nsev23.png"
    },
    {
        "date": "06/01/2023",
        "name": "HackNitr 4.0 Community Partnership",
        "image": "./img/events/nsev22.jpg"
    },
    {
        "date": "03/01/2023",
        "name": "DSA Bootcamp",
        "image": "./img/events/nsev21.jpg"
    },
    {
        "date": "28/12/2022",
        "name": "GeekTalk",
        "image": "./img/events/nsev20.jpg"
    },
    {
        "date": "28/12/2022",
        "name": "Meet & Greet",
        "image": "./img/events/nsev19.png"
    },
    {
        "date": "20/12/2022",
        "name": "Datascience Masterclass",
        "image": "./img/events/nsev18.png"
    },
    {
        "date": "17/12/2022",
        "name": "Cracking Gsoc",
        "image": "./img/events/nscc4.jpeg"
    },
    {
        "date": "11/12/2022",
        "name": "Orientation",
        "image": "./img/events/nscc6.png"
    },
    {
        "date": "07/12/2022",
        "name": "Arrays Masterclass",
        "image": "./img/events/nsev15.png"
    },
    {
        "date": "01/12/2022",
        "name": "DSA Masterclass",
        "image": "./img/events/nsev14.png"
    },
    {
        "date": "30/11/2022",
        "name": "Js Bootcamp",
        "image": "./img/events/nscc5.png"
    },
    {
        "date": "30/11/2022",
        "name": "Coding Challange",
        "image": "./img/events/nsev12.png"
    },
    {
        "date": "25/11/2022",
        "name": "Open Source Webinar",
        "image": "./img/events/nsev11.png"
    },
    {
        "date": "21/11/2022",
        "name": "Interview Masterclass",
        "image": "./img/events/nsev10.png"
    },
    {
        "date": "16/11/2022",
        "name": "Appathon",
        "image": "./img/events/nsev9.png"
    },
    {
        "date": "14/11/2022",
        "name": "Universe Watch Party",
        "image": "./img/events/nscc8.png"
    },
    {
        "date": "27/10/2022",
        "name": "Code to celebrate",
        "image": "./img/events/nsev7.jpg"
    },
    {
        "date": "21/10/2022",
        "name": "Game of codes",
        "image": "./img/events/nsev6.png"
    },
    {
        "date": "16/10/2022",
        "name": "Webinar on Design",
        "image": "./img/events/nsev5.jpg"
    },
    {
        "date": "11/10/2022",
        "name": "ui/ux bootcamp",
        "image": "./img/events/nsev4.png"
    },
    {
        "date": "08/10/2022",
        "name": "Open source and git webinar",
        "image": "./img/events/nsev3.png"
    },
    {
        "date": "28/09/2022",
        "name": "Coding Contest",
        "image": "./img/events/nsev2.jpg"
    },
    {
        "date": "21/09/2022",
        "name": "Code with chef",
        "image": "./img/events/nsev1.jpg"
    }
];
